export default "__VITE_ASSET__0KIpYQNJ__"